import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {HARVEST_RECOMMENDATIONS_FILTERS_STORE_KEY} from 'appConstants';
import {HarvestDemandPutSpeciesEnum, RecommendHarvestsGetSortByEnum} from 'client';

export interface HarvestRecommendationsState {
  sorting?: RecommendHarvestsGetSortByEnum;
  species?: HarvestDemandPutSpeciesEnum;
  excludedProperties?: string[];
}

interface HarvestRecommendationsStateSetters {
  setState: (
    key: keyof HarvestRecommendationsState,
    value: HarvestRecommendationsState[keyof HarvestRecommendationsState],
  ) => void;
  resetFilters: () => void;
}

const getDefaultState = (): HarvestRecommendationsState => {
  return {
    sorting: RecommendHarvestsGetSortByEnum.Score,
    species: HarvestDemandPutSpeciesEnum.Salmon,
    excludedProperties: [],
  };
};

const stores: Record<
  string,
  ReturnType<ReturnType<typeof create<HarvestRecommendationsState & HarvestRecommendationsStateSetters>>>
> = {};

export const createUseHarvestRecommendationsState = (planId: string) => {
  if (stores[planId]) {
    return stores[planId];
  }

  const store = create<HarvestRecommendationsState & HarvestRecommendationsStateSetters>()(
    persist(
      (set) => ({
        ...getDefaultState(),
        setState: (
          key: keyof HarvestRecommendationsState,
          value: HarvestRecommendationsState[keyof HarvestRecommendationsState],
        ) => {
          set({[key]: value});
        },
        resetFilters: () => {
          set({
            sorting: RecommendHarvestsGetSortByEnum.Score,
            species: HarvestDemandPutSpeciesEnum.Salmon,
            excludedProperties: [],
          });
        },
      }),
      {
        name: `${HARVEST_RECOMMENDATIONS_FILTERS_STORE_KEY}-${planId}`,
        partialize: (state) => ({
          sorting: state.sorting,
          species: state.species,
          excludedProperties: state.excludedProperties,
        }),
      },
    ),
  );

  stores[planId] = store;

  return store;
};
